import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { keys } from 'lodash'

import { api, privileges, ui } from '../redux'

import Button from '../components/Button'

const PrivilegeButton = ({ dispatch, privilege, type }) => {
    const key = privileges.TYPES[type]
    const isActive = !!privilege[key]
    const [icon, intent] = isActive
        ? ['md/check', ui.INTENT.success]
        : ['md/clear', ui.INTENT.error]

    const url = api.buildURL('privileges', { id: privilege.id })

    return (
        <Button
            intent={ intent }
            size={ ui.SIZE.large }
            icon={ icon }
            onClick={ () => dispatch(api.update(url, { [key]: !isActive })) }
        />
    )
}

PrivilegeButton.propTypes = {
    dispatch  : PropTypes.func.isRequired,
    privilege : PropTypes.object,
    type      : PropTypes.oneOf(keys(privileges.TYPES))
}

export default connect()(PrivilegeButton)
